const EMPTY_INNER_HTML_PATCH_MARK = '__innovadocEmptyInnerHtmlPatchInstalled__';

type TrustedTypesFactoryLike = object;

type GlobalWithElement = typeof globalThis & {
  Element?: typeof Element;
  trustedTypes?: TrustedTypesFactoryLike;
};

function clearElementChildren(element: Element): void {
  if (typeof element.replaceChildren === 'function') {
    element.replaceChildren();
    return;
  }

  while (element.firstChild) {
    element.firstChild.remove();
  }
}

export function installEmptyInnerHtmlWorkaround(globalScope: GlobalWithElement = globalThis): void {
  if (!globalScope.trustedTypes || !globalScope.Element?.prototype) {
    return;
  }

  const elementPrototype = globalScope.Element.prototype as Element & Record<string, unknown>;
  if (elementPrototype[EMPTY_INNER_HTML_PATCH_MARK]) {
    return;
  }

  const innerHtmlDescriptor = Object.getOwnPropertyDescriptor(globalScope.Element.prototype, 'innerHTML');
  if (!innerHtmlDescriptor?.get || !innerHtmlDescriptor.set) {
    return;
  }

  Object.defineProperty(globalScope.Element.prototype, 'innerHTML', {
    configurable: innerHtmlDescriptor.configurable ?? true,
    enumerable: innerHtmlDescriptor.enumerable ?? false,
    get: innerHtmlDescriptor.get,
    set(this: Element, value: unknown) {
      if (value === '' || value == null) {
        clearElementChildren(this);
        return;
      }

      innerHtmlDescriptor.set?.call(this, value);
    }
  });

  Object.defineProperty(elementPrototype, EMPTY_INNER_HTML_PATCH_MARK, {
    configurable: false,
    enumerable: false,
    writable: false,
    value: true
  });
}